import React from 'react';

const ToggleMenuIcon = React.forwardRef(({
  isExpanded,
  width = 29,
  height = 29,
  circleRadius = 4,
  squareSize = 8,
  color = '#FEFDFB',
  ...props
}, ref) => {
  const positions = {
    circle1: {
      x: isExpanded ? 5.665 : 10,
      y: isExpanded ? 17.001 : 10,
    },
    circle2: {
      x: isExpanded ? 16.977 : 24,
      y: isExpanded ? 5.688 : 10,
    },
    circle3: {
      x: isExpanded ? 16.977 : 10,
      y: isExpanded ? 28.313 : 24,
    },
    circle4: {
      x: isExpanded ? 28.29 : 24,
      y: isExpanded ? 17 : 24,
    },
  };

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 34 34'
      fill='none'
      ref={ref}
      {...props}
    >
      <circle
        cx={positions.circle1.x}
        cy={positions.circle1.y}
        r={circleRadius}
        fill={color}
        className={`circle ${isExpanded ? 'expanded' : 'collapsed'}`}
      />
      <circle
        cx={positions.circle2.x}
        cy={positions.circle2.y}
        r={circleRadius}
        fill={color}
        className={`circle ${isExpanded ? 'expanded' : 'collapsed'}`}
      />
      <circle
        cx={positions.circle3.x}
        cy={positions.circle3.y}
        r={circleRadius}
        fill={color}
        className={`circle ${isExpanded ? 'expanded' : 'collapsed'}`}
      />
      <circle
        cx={positions.circle4.x}
        cy={positions.circle4.y}
        r={circleRadius}
        fill={color}
        className={`circle ${isExpanded ? 'expanded' : 'collapsed'}`}
      />
      <rect
        x={12.977}
        y={13}
        width={squareSize}
        height={squareSize}
        fill={color}
        className={`square ${isExpanded ? 'expanded' : 'collapsed'}`}
      />
    </svg>
  );
});

export default ToggleMenuIcon;
